// extracted by mini-css-extract-plugin
export var cardLayout = "_7w-1";
export var paginationContainer = "_7w-0";